import { fetchAPI } from './fetchAPI';

// ==================== Safety Testing ====================

export const analyzeToxicity = async (text: string, credentialId: string): Promise<any> => {
  return fetchAPI('/genaiops/safety/toxicity/analyze', {
    method: 'POST',
    body: JSON.stringify({ text, credential_id: credentialId }),
  });
};

export const detectPII = async (text: string, useLlm: boolean = false, credentialId: string | null = null): Promise<any> => {
  return fetchAPI('/genaiops/safety/pii/detect', {
    method: 'POST',
    body: JSON.stringify({
      text,
      use_llm: useLlm,
      credential_id: credentialId
    }),
  });
};

export const analyzeBias = async (text: string, credentialId: string): Promise<any> => {
  return fetchAPI('/genaiops/safety/bias/analyze', {
    method: 'POST',
    body: JSON.stringify({ text, credential_id: credentialId }),
  });
};

export const testJailbreak = async (systemPrompt: string, userInput: string, modelOutput: string): Promise<any> => {
  return fetchAPI('/genaiops/safety/jailbreak/test', {
    method: 'POST',
    body: JSON.stringify({
      system_prompt: systemPrompt,
      user_input: userInput,
      model_output: modelOutput
    }),
  });
};

export const generateRedTeamPrompts = async (basePrompt: string, categories: string[] = [], variantsPerCategory: number = 3): Promise<any> => {
  return fetchAPI('/genaiops/safety/red-team', {
    method: 'POST',
    body: JSON.stringify({
      base_prompt: basePrompt,
      categories,
      variants_per_category: variantsPerCategory
    }),
  });
};

export const getSafetyResults = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();
  if (params.evaluationRunId) queryParams.append('evaluation_run_id', params.evaluationRunId);
  if (params.testType) queryParams.append('test_type', params.testType);
  if (params.passedOnly) queryParams.append('passed_only', 'true');
  if (params.failedOnly) queryParams.append('failed_only', 'true');
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);

  const query = queryParams.toString();
  return fetchAPI(`/safety/results${query ? '?' + query : ''}`);
};

// ==================== Assertion Endpoints ====================

export const getAssertionConfigs = async (params: Record<string, any> = {}): Promise<any> => {
  const queryParams = new URLSearchParams();
  if (params.assertionType) queryParams.append('assertion_type', params.assertionType);
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);

  const query = queryParams.toString();
  return fetchAPI(`/genaiops/assertions${query ? '?' + query : ''}`);
};

export const createAssertionConfig = async (assertion: Record<string, any>): Promise<any> => {
  return fetchAPI('/genaiops/assertions', {
    method: 'POST',
    body: JSON.stringify(assertion),
  });
};

export const updateAssertionConfig = async (assertionId: string, updates: Record<string, any>): Promise<any> => {
  return fetchAPI(`/genaiops/assertions/${assertionId}`, {
    method: 'PUT',
    body: JSON.stringify(updates),
  });
};

export const deleteAssertionConfig = async (assertionId: string): Promise<any> => {
  return fetchAPI(`/genaiops/assertions/${assertionId}`, {
    method: 'DELETE',
  });
};

export const validateAssertion = async (assertionType: string, config: Record<string, any>, testValue: string, context: Record<string, any> = {}): Promise<any> => {
  return fetchAPI('/genaiops/assertions/validate', {
    method: 'POST',
    body: JSON.stringify({
      assertion_type: assertionType,
      config,
      test_value: testValue,
      context
    }),
  });
};
